export const SimplifiedDocumentTypes = [
    {
        id: "CC",
        text: "Cédula ciudadania",
    },
    {
        id: "TI",
        text: "Tarjeta identidad",
    },
    {
        id: "CE",
        text: "Cédula extranjeria",
    },
    {
        id: "RC",
        text: "Registro civil",
    },
    {
        id: "PA",
        text: "Pasaporte",
    }
]